/* eslint-disable import/no-cycle */
import { FormInstance } from 'antd';
import AddressSelectorStore from '../stores/AddressSelectorStore';
import { AddressLight } from '../swagger/api';

const getMkAddressObject = (form: FormInstance, addressSelectorStore: AddressSelectorStore) => {
  let mkAddressObject: AddressLight = {
    countryId: '',
    addressLine1: '',
    postalCode: '',
    city: '',
    addressLine2: ''
  };
  const countryName = form.getFieldValue('country');
  const country =
    addressSelectorStore.rootStore.contentStore.genericContentStore.getCountry(countryName);
  const selectedAddres = addressSelectorStore.selectedAddress?.data;
  const streetAndNo = `${selectedAddres?.streetName} ${selectedAddres?.buildingNumber ?? ''}`;
  const floorAndDoor = `${selectedAddres?.floorNumber ? `${selectedAddres?.floorNumber}.` : ''} ${
    selectedAddres?.doorNumber ?? ''
  }`;
  if (addressSelectorStore.useDatafordelerSelector && selectedAddres && country?.id) {
    mkAddressObject = {
      countryId: country.id,
      addressLine1:
        selectedAddres.doorNumber || selectedAddres.floorNumber
          ? `${streetAndNo}, ${floorAndDoor}`
          : streetAndNo,
      postalCode: selectedAddres.postalCode,
      city: selectedAddres.cityName,
      addressLine2: form.getFieldValue('addressLine2')
    };
    return mkAddressObject;
  }
  if (addressSelectorStore.useDatafordelerSelector && selectedAddres === undefined && country?.id) {
    const addressLine = form.isFieldTouched('datafordelerAddress')
      ? form.getFieldValue('datafordelerAddress')
      : addressSelectorStore.rootStore.userStore.currentAccount?.streetName;
    const postalCode = addressSelectorStore.rootStore.userStore.currentAccount?.zipCode;
    const city = addressSelectorStore.rootStore.userStore.currentAccount?.cityName;
    const addressLine2 = form.getFieldValue('addressLine2');
    if (addressLine && postalCode && city)
      mkAddressObject = {
        countryId: country.id,
        addressLine1: addressLine,
        postalCode,
        city,
        addressLine2
      };
    return mkAddressObject;
  }
  if (country?.id) {
    mkAddressObject = {
      countryId: country.id,
      addressLine1: form.getFieldValue('addressLine'),
      postalCode: form.getFieldValue('zipCode'),
      city: form.getFieldValue('city'),
      addressLine2: form.getFieldValue('addressLine2')
    };
    return mkAddressObject;
  }
  return mkAddressObject;
};

export default getMkAddressObject;
